const router = require("services/router");

function iconAnimation() {

	const particleSpawner = document.getElementById("partical-generator-find");
	const programmingLanguages = document.getElementById("partical-generator-date");
	const gradeSpawner = document.getElementById("partical-generator-grades");

	var w = window.innerWidth;

	// This prevents errors if the element is missing
	if (programmingLanguages == undefined) {
		return;
	}else if(w < 580){
		changeIcons();
		return;
	}else if(detectIE() != false){
		changeIcons();
		return;
	}

	function changeIcons(){
		document.getElementById("timg").src=router.url("img/icons/teacher-p.svg");
		document.getElementById("dimg").src=router.url("img/icons/date-p.svg");
		document.getElementById("rimg").src=router.url("img/icons/results-p.svg");
	}

	function detectIE() {
	    var ua = window.navigator.userAgent;

	    var msie = ua.indexOf('MSIE ');
	    if (msie > 0) {
	        // IE 10 or older => return version number
	        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	    }

	    var trident = ua.indexOf('Trident/');
	    if (trident > 0) {
	        // IE 11 => return version number
	        var rv = ua.indexOf('rv:');
	        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
	    }

	    var edge = ua.indexOf('Edge/');
	    if (edge > 0) {
	       // Edge (IE 12+) => return version number
	       return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
	    }

	    // other browser
	    return false;
	}

	const pipe = (...functions) => arg => functions.reduce((a, b) => b(a), arg);

	const define = (object, property, value) =>
		Object.defineProperty(object, property, {
			value,
			writable: true,
			configurable: true,
			enumerable: true
		});

	const interval = (callback, delay) => {
		const tick = now => {
			if (now - start >= delay) {
				start = now;
				callback();
			}
			requestAnimationFrame(tick);
		};
		let start = performance.now();
		requestAnimationFrame(tick);
	};

	const getRandomInt = (min, max) =>
		Math.floor(Math.random() * (max - min)) + min;

	// easing equations
	// ===============================================================================================

	const easeInQuart = (t, b, c, d) =>
		c * (t /= d) * Math.pow(t, 3) + b;

	const easeOutQuart = (t, b, c, d) =>
		-c * ((t = t / d - 1) * Math.pow(t, 3) - 1) + b;

	const easeInOutQuart = (t, b, c, d) => {
		if ((t /= d / 2) < 1) return c / 2 * Math.pow(t, 4) + b;
		return -c / 2 * ((t -= 2) * Math.pow(t, 3) - 2) + b;
	};

	const easeInOutBack = (t, b, c, d, s) => {
		if (s == undefined) s = 1.70158;
		if ((t /= d / 2) < 1) return c / 2 * (t * t * (((s *= (1.525)) + 1) * t - s)) + b;
		return c / 2 * ((t -= 2) * t * (((s *= (1.525)) + 1) * t + s) + 2) + b;
	};

	const easeOutElastic = (t, b, c, d, frequency = 700) => {
		if (t == 0 || c == 0) return b;
		if ((t /= d) == 1) return b + c;
		const a = c;
		const p = d * (1 - Math.min(frequency, 999) / 1000);
		const s = a < Math.abs(c) ? p / 4 : p / (2 * Math.PI) * Math.asin(c / a);
		return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
	};

	// Icon animation
	// ===============================================================================================

	if (typeof(programmingLanguages) != 'undefined' && programmingLanguages != null) {
		const languages = [
			"circle-grey",
			"circle",
			"close",
			"dot",
			"grey-dot",
			"lines",
			"plus",
			"small-circle",
			"square",
			"triangle-colored",
			"triangle"
		];

		const grades = [
			"02",
			"04-colored",
			"04-grey",
			"04-small",
			"07-colored",
			"07-grey",
			"07",
			"10-small",
			"10",
			"12"
		];

		var intFirst,
			intSecond,
			intThird;

		var gTime = 7000,
			gMaxDistance = 140,
			gMaxRotation = 800;

		const getRandomLanguage = () =>
			languages[getRandomInt(0, languages.length)];

		const getRandomGrade = () =>
			grades[getRandomInt(0, grades.length)];

		const getRandomY = (x, min, max) => {
			if (Math.abs(x) > min) return getRandomInt(-max, max);
			const minY = Math.sqrt(Math.pow(min, 2) - Math.pow(x, 2));
			const randomSign = Math.round(Math.random()) * 2 - 1;
			return randomSign * getRandomInt(minY, max);
		};

		const createIconParticle = particle => {
			if (!isPaused) {
				const icon = document.createElement("img");
				icon.alt = particle;
				icon.src = router.url(`img/icons/particles/${particle}.svg`);
				particleSpawner.appendChild(icon);
				return icon;
			}
		};

		const createIcon = language => {
			if (!isPaused) {
				const icon = document.createElement("img");
				icon.alt = language;
				icon.src = router.url(`img/icons/particles/${language}.svg`);
				programmingLanguages.appendChild(icon);
				return icon;
			}
		};

		const createIconGrades = grade => {
			if (!isPaused) {
				const icon = document.createElement("img");
				icon.alt = grade;
				icon.src = router.url(`img/icons/particles/grades/${grade}.svg`);
				gradeSpawner.appendChild(icon);
				return icon;
			}
		};

		const animateIconParticle = iconTwo => {
			if (!isPaused) {
				const time = {total: gTime};
				const maxDistance = gMaxDistance;
				const maxRotation = gMaxRotation;
				const transform = {};
				define(transform, "translateX", getRandomInt(-maxDistance, maxDistance));
				define(transform, "translateY", getRandomY(transform.translateX, 135, maxDistance));
				define(transform, "rotate", getRandomInt(-maxRotation, maxRotation));

				const tick = now => {
					if (time.start == null) define(time, "start", now);
					define(time, "elapsed", now - time.start);
					const progress = easeOutQuart(time.elapsed, 0, 1, time.total);

					iconTwo.style.opacity = Math.abs(1 - progress);
					iconTwo.style.transform = Object.keys(transform).map(key => {
						const value = transform[key] * progress;
						const unit = /rotate/.test(key) ? "deg" : "px";
						return `${key}(${value}${unit})`;
					}).join(" ");

					time.elapsed < time.total ?
						requestAnimationFrame(tick) :
						particleSpawner.removeChild(iconTwo);
				};

				requestAnimationFrame(tick);
			}
		};

		const animateIcon = icon => {
			if (!isPaused) {
				const time = {total: gTime};
				const maxDistance = gMaxDistance;
				const maxRotation = gMaxRotation;
				const transform = {};
				define(transform, "translateX", getRandomInt(-maxDistance, maxDistance));
				define(transform, "translateY", getRandomY(transform.translateX, 135, maxDistance));
				define(transform, "rotate", getRandomInt(-maxRotation, maxRotation));

				const tick = now => {
					if (time.start == null) define(time, "start", now);
					define(time, "elapsed", now - time.start);
					const progress = easeOutQuart(time.elapsed, 0, 1, time.total);

					icon.style.opacity = Math.abs(1 - progress);
					icon.style.transform = Object.keys(transform).map(key => {
						const value = transform[key] * progress;
						const unit = /rotate/.test(key) ? "deg" : "px";
						return `${key}(${value}${unit})`;
					}).join(" ");

					time.elapsed < time.total ?
						requestAnimationFrame(tick) :
						programmingLanguages.removeChild(icon);
				};

				requestAnimationFrame(tick);
			}
		};

		const animateGrades = iconThree => {
			if (!isPaused) {
				const time = {total: gTime};
				const maxDistance = gMaxDistance;
				const maxRotation = gMaxRotation;
				const transform = {};
				define(transform, "translateX", getRandomInt(-maxDistance, maxDistance));
				define(transform, "translateY", getRandomY(transform.translateX, 135, maxDistance));
				define(transform, "rotate", getRandomInt(-maxRotation, maxRotation));

				const tick = now => {
					if (time.start == null) define(time, "start", now);
					define(time, "elapsed", now - time.start);
					const progress = easeOutQuart(time.elapsed, 0, 1, time.total);

					iconThree.style.opacity = Math.abs(1 - progress);
					iconThree.style.transform = Object.keys(transform).map(key => {
						const value = transform[key] * progress;
						const unit = /rotate/.test(key) ? "deg" : "px";
						return `${key}(${value}${unit})`;
					}).join(" ");

					time.elapsed < time.total ?
						requestAnimationFrame(tick) :
						gradeSpawner.removeChild(iconThree);
				};

				requestAnimationFrame(tick);
			}
		};

		intFirst = setInterval(pipe(getRandomLanguage, createIconParticle, animateIconParticle), 400);
		intSecond = setInterval(pipe(getRandomLanguage, createIcon, animateIcon), 400);
		intThird = setInterval(pipe(getRandomGrade, createIconGrades, animateGrades), 400);

		var isPaused = false;

		window.addEventListener('blur', function () {
			isPaused = true;

			clearInterval(intFirst);
			clearInterval(intSecond);
			clearInterval(intThird);

		});

		window.addEventListener('focus', function () {
			isPaused = false;

			intFirst = setInterval(pipe(getRandomLanguage, createIconParticle, animateIconParticle), 400);
			intSecond = setInterval(pipe(getRandomLanguage, createIcon, animateIcon), 400);
			intThird = setInterval(pipe(getRandomGrade, createIconGrades, animateGrades), 400);
			
		});

	}
}

module.exports = iconAnimation;


// WEBPACK FOOTER //
// ./resources/js/modules/icon-animation.js